import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
export default store => ({
  path: "ecoursework/:yearGroupId/studentview/:studentId(/:projectGroupId)",
  exact: true,
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "ecoursework" */ "./components"),
        import(
          /* webpackChunkName: "ecoursework" */ "IB_ECoursework/modules/ECourseworkModule"
        ),
        import(
          /* webpackChunkName: "ecoursework" */ "Projects/modules/ProjectModules.js"
        ),
      ]).then(([importedModule0, importedModule1, importedModule2]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        const projectReducer = importedModule2;
        injectReducer(store, {
          key: "eCoursework",
          reducer,
        });
        injectReducer(store, {
          key: projectReducer.NAME,
          reducer: projectReducer.default,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [],
});
